// extracted by mini-css-extract-plugin
module.exports = {"Banner":"admin-portal__SupplyNetworks__Banner","BannerButton":"admin-portal__SupplyNetworks__BannerButton"};